<template>
  <div class="col-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="数据源" name="1">
        <div class="dataSource-item mb16">
          <span class="linkDataBtn" @click="goToChooseData">进入数据管理后台</span>
        </div>
        <auto-update-timer :isLocal="false"/>
        <div>
          <div class="getDataBtn mb16" @click="startDraw">查看数据响应结果</div>
          <el-button
            v-if="noCacheComponent && request_prefix === 'bigScreen'"
            class="clear-url-btn"
            @click="clearRestDataUrlFunc"
            >清空数据源</el-button
          >
          <cx-check-box  v-if="request_prefix==='bigScreen'"  :value.sync="usePageQuery">开启跨页面传参</cx-check-box>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown($event, '2')"
        title="字段匹配"
        name="2"
        class="mapping_container"
        v-if="getAllElements"
      >
        <div
          v-for="(item, index) in getAllElements"
          :key="index"
          class="mapping_content"
          @mouseenter="highlightedBaseComponent(item.elementInSwiperId)"
          @mouseleave="cancelHighlightedBaseComponent(item.elementInSwiperId)"
        >
          <div class="verticallyBetweenCenter">
            <div>
              <el-checkbox
                v-model="item.filedMapping.flag"
                @change="changeFiledMappingHandle($event, { elementInSwiperId: item.elementInSwiperId, flag: 'flag' })"
              ></el-checkbox
              ><label>{{ getValueByTypeHandle(item.innerElement) }}</label>
            </div>
            <div class="verticallyCenter mapping_date_content" v-if="item.filedMapping.isDate">
              <label class="DateLabel">格式：</label>
              <div>
                <el-select
                  style="width: 87px"
                  popper-class="date-style-select"
                  v-model="item.filedMapping.dateStyle"
                  @change="startDraw"
                  placeholder="请选择"
                >
                  <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if="item.innerElement == 'cxVideo' || item.innerElement == 'cxAudio'">
              <el-checkbox v-model="item.videoObjectId"></el-checkbox><label>支持云盘</label>
            </div>
          </div>
          <div
            class="verticallyCenter mapping_date_content mt8"
            v-if="item.innerElement == 'cxText' && !item.filedMapping.isDate && item.filedMapping.flag"
          >
            <label class="DateLabel">格式：</label>
            <div class="flex1">
              <el-select
                style="width: 100%"
                popper-class="date-style-select"
                v-model="item.filedMapping.dataType"
                placeholder="请选择"
                @change="
                  changeFiledMappingHandle(
                    $event,
                    {
                      elementInSwiperId: item.elementInSwiperId,
                      flag: 'dataType'
                    },
                    true
                  )
                "
              >
                <el-option v-for="item in dataTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="select_content">
            <el-select
              v-if="item.filedMapping.flag"
              v-model="item.filedMapping.value"
              @change="
                changeFiledMappingHandle(
                  $event,
                  {
                    elementInSwiperId: item.elementInSwiperId,
                    flag: 'value'
                  },
                  true
                )
              "
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index1) in filedMappingList"
                :key="index1"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '3')" title="同步" name="3">
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
          <div class="setting-item syncCol_flex">
            请选择需要同步的单元格<span @click="syncCol" class="syncCol_btn">同步</span>
          </div>
          <div class="setting-item syncCol_content">
            <el-checkbox
              v-model="getAllColsIsCheckedAll"
              :indeterminate="allColsIsCheckedAll"
              class="ml8"
              @change="checkAllColsHandle"
            ></el-checkbox
            ><label>全部</label>
            <li v-for="(item, index) in allCols" class="col_li" :key="index">
              <el-checkbox v-model="item.isChecked" @change="changeColsCheckedHandle($event, index)"></el-checkbox>
              <label>单元格{{ index }}</label>
            </li>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown($event, '4')"
        title="链接跳转"
        name="4"
        v-if="getAllElements && request_prefix !== 'bigScreen'"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
          <div class="setting-item">请选择点击区域</div>
          <div class="setting-item syncCol_content">
            <el-checkbox
              v-model="getAllElementsIsCheckedAll"
              :indeterminate="allElementsIsCheckedAll"
              class="ml8"
              @change="checkAllElementsHandle"
            ></el-checkbox
            ><label>全部</label>
            <li
              v-for="(item, index) in getAllElements"
              class="col_li"
              :key="index"
              @mouseenter="highlightedBaseComponent(item.elementInSwiperId)"
              @mouseleave="cancelHighlightedBaseComponent(item.elementInSwiperId)"
            >
              <el-checkbox
                v-model="item.filedMapping.checked"
                @change="
                  changeFiledMappingHandle($event, { elementInSwiperId: item.elementInSwiperId, flag: 'checked' })
                "
              ></el-checkbox>
              <span>{{ getValueByTypeHandle(item.innerElement) }}</span>
            </li>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import { UpdateData } from "utils/updateData/swiper/swiperComponentUpdateData.js"
import { getValueByType } from "utils"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
export default {
  components: { autoUpdateTimer },
  props: {
    options: { type: Object }
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      changeAll: false,
      preventRadio: null,
      preventType: null,
      chooseFromVisable: false,
      colsIdFromActiveRect: [],
      cacheDataTypes: [],
      restDataUrl: null,
      otherParams: null,
      activeNames: ["1"],
      collapseActiveNames: [],
      completeData: [],
      filedMappingList: [], // 用来做映射的字段集合
      allCols: [], // 用来做需要同步的content集合
      allColsIsCheckedAll: false,
      getAllColsIsCheckedAll: false, // 是否全选所有content
      allElementsIsCheckedAll: false,
      getAllElementsIsCheckedAll: false, //是否全选所有元素
      checkedCols: [],
      detailPageElementIndexList: [], //当前content中可以跳转链接的组件
      fetchEnd: false,
      dateOptions: [
        {
          value: "7",
          label: "年-月-日 时:分:秒"
        },
        {
          value: "10",
          label: "年-月-日 时:分"
        },
        {
          value: "1",
          label: "年-月-日"
        },
        {
          value: "2",
          label: "年-月"
        },
        {
          value: "3",
          label: "月-日"
        },
        {
          value: "8",
          label: "时:分"
        },
        {
          value: "4",
          label: "年"
        },
        {
          value: "5",
          label: "月"
        },
        {
          value: "6",
          label: "日"
        },
        {
          value: "9",
          label: "文本格式"
        }
      ],
      dataTypeList: [
        {
          label: "字段名称：字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        },
        {
          label: "字段名称",
          value: "dataName"
        }
      ]
    }
  },
  computed: {
    getOptions() {
      let swiperId = this.ids?.hasOwnProperty("swiperContent_id") ? { ...this.ids, swiperContent_id: null } : this.ids
      if (this.ids.elementInAutoLayoutId !== undefined && this.ids.elementInAutoLayoutId !== null) {
        return this.getAttrById(
          this.$store.state[this.request_prefix],
          swiperId,
          "elementInAutoLayout"
        )
      }
      return this.getRectAttribute.call(this, swiperId).options
    },
    typeVal: {
      get() {
        return this.options.myFetchParam ? this.options.myFetchParam.typeVal : null
      },
      set(val) {
        this.$changeOptionsEV(
          val,
          "typeVal",
          true,
          "myFetchParam",
          {
            rect_id: this.ids.rect_id,
            container_id: this.ids.container_id,
            elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
            path: this.ids.path
          },
          true
        )
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false, null, {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        })
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        })
        const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
        const rectAttr = this.getRectAttribute(this.ids)
        let appId = this.getOptions.appId || rectAttr.options.appId
        this.$changeOptionsEV(
          {
            typeVal: this.cacheDataTypes.length ? this.cacheDataTypes[0].publicId : "",
            restDataUrl: this.restDataUrl,
            pageId,
            wfwfid,
            websiteId,
            appId
          },
          "myFetchParam",
          false,
          null,
          {
            rect_id: this.ids.rect_id,
            container_id: this.ids.container_id,
            elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
            path: this.ids.path
          },
          true
        )
      }
    },
    getAllElements() {
      if (
        typeof this.ids.swiperContent_id !== "number" ||
        this.ids.swiperContent_id === undefined ||
        this.ids.swiperContent_id === null
      )
        return
      let checkedLength = 0
      const rectAttr = this.getOptions.content
      const pOptions = rectAttr[this.ids.swiperContent_id]?.elementOptions
      if (!pOptions) return
      for (let i = 0; i < pOptions.length; i++) {
        if (pOptions[i].filedMapping?.checked) checkedLength++
        const newVal = this.checkAndSetPrimaryVal(pOptions[i], "filedMapping", "filedMapping", {
          value: null,
          label: null,
          flag: false,
          checked: false,
          isDate: false,
          dateStyle: "1",
          dataType: "dataValue"
        })
        if (newVal) {
          // 以前未设置的 加个默认值
          if (!newVal.dataType) {
            newVal.dataType = "dataValue"
          }
          this.$changeOptionsEV(
            newVal,
            "filedMapping",
            false,
            null,
            {
              rect_id: this.ids.rect_id,
              container_id: this.ids.container_id,
              swiperContent_id: this.ids.swiperContent_id,
              elementInSwiperId: pOptions[i].elementInSwiperId,
              elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
              path: this.ids.path
            },
            true
          )
        }
      }
      if (checkedLength === pOptions.length) this.getAllElementsIsCheckedAll = true
      return pOptions
    }
  },
  methods: {
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    collapseMouseDown($event, val) {
      if (val === "2" && this.filedMappingList.length === 0 && this.noCacheComponent) {
        this.getBaseModuleDataLoop()
      }
      if (val === "3" && this.allCols.length === 0) {
        this.getAllCols()
      }
      if (val === "4" && this.allCols.length === 0) {
        this.initDetailsPageHandle()
      }
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    setMyFetchParam() {
      const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(this.ids)
      let appId = this.getOptions?.appId || rectAttr.options.appId
      this.$changeOptionsEV(
        {
          typeVal: this.cacheDataTypes.map(it => it.publicId),
          restDataUrl: this.restDataUrl,
          pageId,
          wfwfid,
          websiteId,
          appId
        },
        "myFetchParam",
        false,
        null,
        {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        },
        true
      )
    },
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId, sign, wfwfid } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(this.ids)
      let { moduleId, appId } = this.getOptions
      if (moduleId === undefined) moduleId = this.getOptions?.moduleId
      if (appId === undefined) appId = this.getOptions?.appId
      if (!!!appId) {// 没有moduleId但是有appId时会重新进入 仅用appId判断
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时")
          .then(res => {
            this.fetchEnd = false
            if (!!res.appId) {
              window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&init=1`)
              this.setMyFetchParam()
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (!!appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}`)
      // 数据自动渲染
      window.addEventListener("storage", this.listenStorage)
    },
    // 获取当前tab下面的所有col
    getAllCols() {
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      let syncColUids = this.getOptions.content // 除去当前选中的col的所有col的uid集合
      syncColUids = [...syncColUids.filter(item => item.swiperContent_id !== this.ids.swiperContent_id)]
      for (let i = 0; i < syncColUids.length; i++) {
        const obj = {
          swiperContent_id: syncColUids[i].swiperContent_id,
          isChecked: false
        }
        this.allCols.push(obj)
      }
    },
    // 获取所有content
    getAllContent() {
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      const list = this.getOptions.content
      for (let i = 0; i < list.length; i++) {
        const obj = {
          swiperContent_id: list[i].swiperContent_id,
          isChecked: false
        }
        this.allCols.push(obj)
      }
    },
    async getBaseModuleDataLoop() {
      const updateData = new UpdateData(this)
      const { engineInstanceId, cacheDataTypes, restDataUrl, restUrl } = await this.getAppointDataEv()
      this.$changeOptionsEV(
        [engineInstanceId, cacheDataTypes.length ? cacheDataTypes[0].publicId : ""],
        ["engineInstanceId", "myFetchParam.typeVal"],
        false,
        null,
        {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        },
        true
      )
      this.restDataUrl = restDataUrl
      let drawLayoutAlready, completeData
      const updateCb = (val, content_name, deep, deepName, ids) => {
        this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
      }
      if (this.ids.swiperContent_id === undefined) return
      try {
        ;[drawLayoutAlready, completeData] = await updateData.upDateRect(
          this.getOptions,
          cacheDataTypes,
          restDataUrl,
          this.ids,
          updateCb
        )
        if (completeData && this.ids.swiperContent_id !== null && completeData[this.ids.swiperContent_id]) {
          // 组装字段映射的数据结构
          Object.keys(completeData[this.ids.swiperContent_id]).forEach((key, index) => {
            if (key && key !== "url" && key !== "publicId") {
              const temp = {
                value: key,
                label: completeData[this.ids.swiperContent_id][key]
                  ? completeData[this.ids.swiperContent_id][key].key
                  : ""
              }
              if (completeData[this.ids.swiperContent_id][key] && completeData[this.ids.swiperContent_id][key].key)
                this.filedMappingList.push(temp)
            }
          })
        }
        this.completeData = completeData
      } catch (error) {
        console.log(error)
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: error.message == 1 ? "数据请求失败" : "后台数据为空"
        })
      }
    },
    async getAppointDataEv() {
      const { websiteId, pageId, sign, wfwfid } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(this.ids)
      const appId = this.getOptions.appId ? this.getOptions.appId : this.getOptions.myFetchParam.appId
      return await getAppointCacheData.call(this, pageId, wfwfid, websiteId, appId)
    },
    async startDraw() {
      if (!(await this.showDataSetting()) || !this.noCacheComponent) return
      const updateData = new UpdateData(this)
      let drawLayoutAlready, completeData
      const updateCb = (val, content_name, deep, deepName, ids) => {
        this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
      }
      try {
        ;[drawLayoutAlready, completeData] = await updateData.upDateRect(
          this.getOptions,
          this.cacheDataTypes,
          this.restDataUrl,
          this.ids,
          updateCb
        )
      } catch (error) {
        console.log(error)
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: error.message == 1 ? "数据请求失败" : "后台数据为空"
        })
      }
      this.drawData(drawLayoutAlready, completeData, updateData)
    },
    //根据数据绘制应用
    async drawData(drawLayoutAlready, completeData, updateData) {
      const createCb = param => {
        this.$store.dispatch(this.request_prefix + "/addComponentInSwiper", param)
      }
      const updateCb = (val, content_name, deep, deepName, ids) => {
        this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
      }
      const delSlideCb = param => {
        this.$store.dispatch(this.request_prefix + "/swiperContentControl", param)
      }
      if (drawLayoutAlready) {
        updateData.updateSwiperContent({ completeData, drawLayoutAlready, createCb, updateCb, delSlideCb })
      } else {
        updateData.updateSwiperContent({ completeData, createCb, updateCb, delSlideCb })
      }
    },

    //区分不同组件的option_name不一致的问题
    fiexOptName(shape) {
      let result = null
      switch (shape) {
        case "cxText":
          result = "content"
          break
        case "imageComponent":
          result = "imgSrc"
          break

        default:
          break
      }
      return result
    },

    getUserChoose(word) {
      let _message = ""
      switch (word) {
        case "someAlready":
          _message = "检测到您在应用中已绘制的组件数量与后台选择的数据数量不一致，是否继续生成？"
          break
        case "allDone":
          _message = "检测到您已经绘制好了布局，是否按照您的布局自动生成所有区域？"
          break
        case "empty":
          _message = "检测到您未进行任何绘制，是否为您自动生成组件?"
          break
        case "untidy":
          _message = "检测到您绘制的内容与实际数据内容不符 是否为您自动修复并生成？"
          break
        default:
          break
      }
      return this.$confirm(_message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        dangerouslyUseHTMLString: `<p>${_message}</p>`,
        iconClass: "bigScreen_confirm_icon el-icon-warning",
        cancelButtonClass: "bigScreen_confirm_cancel_button",
        confirmButtonClass: "bigScreen_confirm_button",
        customClass: "bigScreen_confirm custom_warning_dialog"
      })
        .then(() => {
          return true
        })
        .catch(() => {
          return false
        })
    },

    checkStatus() {
      return this.getOptions?.appId
    },
    async showDataSetting() {
      if (!!!this.checkStatus()) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return false
      }
      this.noCacheComponent = true
      this.chooseFromVisable = !this.chooseFromVisable
      const rectAttr = this.getRectAttribute(this.ids)
      if (!this.getOptions?.myFetchParam) return false
      const { pageId, wfwfid, websiteId, appId } = this.getOptions?.myFetchParam
      const { cacheDataTypes, restDataUrl, restUrl } = await getAppointCacheData.call(
        this,
        pageId,
        wfwfid,
        websiteId,
        appId
      )
      this.restDataUrl = restDataUrl
      this.cacheDataTypes = cacheDataTypes
      return true
    },
    // 改变filedMapping的值
    changeFiledMappingHandle(data, params, isGetData) {
      let ids = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        swiperContent_id: this.ids.swiperContent_id,
        elementInSwiperId: params.elementInSwiperId
      }
      if (this.ids.elementInAutoLayoutId) {
        ids = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          swiperContent_id: this.ids.swiperContent_id,
          elementInSwiperId: params.elementInSwiperId,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        }
      }
      let currentFiledMapping = JSON.parse(JSON.stringify(this.$getOptions(ids).filedMapping))
      if (params.flag === "flag") {
        currentFiledMapping.flag = data
        if (!currentFiledMapping.flag) {
          currentFiledMapping.value = null
        }
      } else if (params.flag === "checked") {
        currentFiledMapping.checked = data
        this.changeLinksHandle(data, params.elementInSwiperId)
      } else if (params.flag !== "dataType") {
        currentFiledMapping.value = data
        // 判断当前选中字段类型，如果是日期字段，则需要显示日期格式设置项
        const tempComplete = this.completeData[this.ids.swiperContent_id]
        if (!tempComplete) return
        Object.keys(tempComplete).forEach(key => {
          if (key === data) {
            currentFiledMapping.dateStyle = "1"
            if (tempComplete[key].component_shape?.includes("cxDate")) {
              currentFiledMapping.isDate = true
            } else {
              currentFiledMapping.isDate = false
            }
          }
        })
      }
      this.$changeOptionsEV(
        currentFiledMapping,
        "filedMapping",
        false,
        null,
        {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          swiperContent_id: this.ids.swiperContent_id,
          elementInSwiperId: params.elementInSwiperId,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        },
        true
      )

      // 手动触发一次数据响应
      if (isGetData) {
        this.startDraw()
      }
    },
    // 改变跳转组件
    changeLinksHandle(flag, index) {
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      let detailsPageTarget = this.getOptions?.content[this.ids.swiperContent_id]?.options?.detailsPageTarget || []
      let detailPageElementIndexList = [...detailsPageTarget]
      if (flag) {
        detailPageElementIndexList.push(index)
      } else {
        detailPageElementIndexList = detailPageElementIndexList.filter(val => val !== index)
      }
      // 全选按钮状态控制
      if (detailPageElementIndexList.length === 0) {
        this.allElementsIsCheckedAll = false
        this.getAllElementsIsCheckedAll = false
      } else {
        if (detailPageElementIndexList.length !== this.getAllElements.length) {
          this.allElementsIsCheckedAll = true
        } else {
          this.allElementsIsCheckedAll = false
        }
      }
      const result = {
        content: detailPageElementIndexList,
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        swiperContent_id: this.ids.swiperContent_id,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path
      }
      this.$store.dispatch(this.request_prefix + "/swiperContentOptionsUpdate", result)
    },
    // 高亮显示当前组件
    highlightedBaseComponent(index) {
      const container = document
        .getElementsByClassName(`container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)[0]
        .querySelector(`.swiper-slide.swiperSlide${this.ids.swiperContent_id} .componentBox`)
      const _class = `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-swiperContent_id_${this.ids.swiperContent_id}-elementInSwiperId_${index}`
      const dom = document.getElementsByClassName(_class)
      const box = document.createElement("div") //创建元素
      if (!dom[0]) return
      const styleObject = {
        transform: dom[0].style.transform,
        position: "absolute",
        background: "rgba(118, 163, 211, 0.7);",
        width: dom[0].style.width,
        height: dom[0].style.height
      }
      let styleArr = []
      Object.keys(styleObject).forEach(key => {
        styleArr.push([key, styleObject[key]].join(":"))
      })
      box.setAttribute(
        "id",
        `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-swiperContent_id_${this.ids.swiperContent_id}-elementInSwiperId_${index}-mask`
      )
      box.setAttribute("style", styleArr.join(";"))
      container.appendChild(box)
    },
    // 取消高亮显示当前组件
    cancelHighlightedBaseComponent(index) {
      if (
        document.getElementById(
          `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-swiperContent_id_${this.ids.swiperContent_id}-elementInSwiperId_${index}-mask`
        )
      ) {
        document
          .getElementById(
            `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-swiperContent_id_${this.ids.swiperContent_id}-elementInSwiperId_${index}-mask`
          )
          .remove()
      }
    },
    // 同步当前col
    syncCol() {
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      // const pOptions = rectAttr.options.content[this.ids.swiperContent_id].elementOptions
      let pOptions = this.getOptions?.content[0]
      if (this.ids.hasOwnProperty("swiperContent_id")) {
        pOptions = this.getOptions?.content[this.ids.swiperContent_id]
      }
      let syncFlag = false
      for (let i = 0; i < this.allCols.length; i++) {
        if (this.allCols[i].isChecked) {
          const result = {
            content: JSON.parse(JSON.stringify(pOptions)),
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            swiperContent_id: this.allCols[i].swiperContent_id,
            elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
            path: this.ids.path
          }
          this.$store.dispatch(this.request_prefix + "/swiperContentUpdate", result)
          syncFlag = true
        }
      }
      if (syncFlag) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "同步成功",
          type: "success"
        })
      }
      // 重新响应数据
      this.startDraw()
    },
    changeColsCheckedHandle(val, index) {
      let checkedCols = 0
      this.allCols[index].isChecked = val
      this.allCols.map(item => {
        if (item.isChecked) {
          checkedCols++
        }
      })
      if (checkedCols === 0) {
        this.allColsIsCheckedAll = false
        this.getAllColsIsCheckedAll = false
      } else {
        if (checkedCols !== this.allCols.length) {
          this.allColsIsCheckedAll = true
        } else {
          this.allColsIsCheckedAll = false
          this.getAllColsIsCheckedAll = true
        }
      }
    },
    // 打开跳转链接抽屉的时候，初始化
    initDetailsPageHandle() {
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      const pOptions = this.getOptions?.content[this.ids.swiperContent_id].options
      if (!pOptions.detailsPageTarget) {
        // 兼容老组件，没有跳转详情配置项
        const result = {
          content: [],
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          swiperContent_id: this.ids.swiperContent_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        }
        this.$store.dispatch(this.request_prefix + "/swiperContentOptionsUpdate", result)
        this.detailPageElementIndexList = []
      } else {
        this.detailPageElementIndexList = Array.isArray(pOptions.detailsPageTarget)
          ? [...pOptions.detailsPageTarget]
          : []
      }
    },
    // 选中所有col
    checkAllColsHandle($event) {
      this.allElementsIsCheckedAll = false // 去掉部分选中状态
      this.allCols.map(item => (item.isChecked = $event))
    },
    // 选中所有元素
    checkAllElementsHandle($event) {
      this.allElementsIsCheckedAll = false // 去掉部分选中状态
      for (let i = 0; i < this.getAllElements.length; i++) {
        this.changeFiledMappingHandle($event, {
          elementInSwiperId: this.getAllElements[i].elementInSwiperId,
          flag: "checked"
        })
      }
    },
    // 清空自由布局外接数据源地址与数据
    clearRestDataUrlFunc() {
      this.$confirm("确认清空数据源？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          //基础组件还原为默认的
          this.clearData()
          this.$message({
            type: "success",
            duration: 2000,
            message: "清空成功!"
          })
        })
        .catch(action => {
          if (action === "cancel") return
          this.$message({
            type: "info",
            message: "清空失败"
          })
        })
    },
    //清空组件数据
    clearData() {
      this.restDataUrl = ""
      let emptyDataLists = [
        { name: "noCacheComponent", value: false },
        { name: "emptyData", value: false },
        { name: "appId", value: "" },
        { name: "moduleId", value: "" },
        { name: "engineInstanceId", value: "" },
        { name: "typeId", value: "" },
        { name: "myFetchParam", value: {} }
      ]
      for (let i = 0; i < emptyDataLists.length; i++) {
        this.$changeOptionsEV(
          emptyDataLists[i].value,
          emptyDataLists[i].name,
          false,
          null,
          {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
            path: this.ids.path
          },
          true
        )
      }
      const menus = this.$store.state.bigScreenMenu.menu.children.find(it => it.name === "基础").children
      let content = this.options.content
      if (content.length > 0) {
        for (let i = 0; i < content.length; i++) {
          if (content[i].elementOptions?.length > 0) {
            let tempList = content[i].elementOptions
            if (typeof tempList !== "undefined" && tempList.length > 0) {
              tempList.forEach(elementOptions => {
                let itemShapeName = elementOptions.innerElement
                let _attribute = menus.find(item => itemShapeName === item.type)
                let param = {}
                if (itemShapeName === "cxText") {
                  param.option_name = "content"
                  param.option_val = _attribute?.children[0].attribute.options.content
                } else if (itemShapeName === "imageComponent" || itemShapeName === "cxBorder") {
                  param.option_name = "imgSrc"
                  param.option_val = _attribute?.children[0].attribute.options.imgSrc
                } else if (itemShapeName === "cxVideo") {
                  param.option_name = "videoUrl"
                  param.option_val = _attribute?.children[0].attribute.options.videoUrl
                } else if (itemShapeName === "cxButton") {
                  param.option_name = "content"
                  param.option_val = "查看"
                }
                this.$changeOptionsEV(
                  param.option_val,
                  param.option_name,
                  false,
                  null,
                  {
                    rect_id: this.ids.rect_id,
                    container_id: this.ids.container_id,
                    elementInSwiperId: elementOptions.elementInSwiperId,
                    swiperContent_id: content[i].swiperContent_id,
                    elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
                    path: this.ids.path
                  },
                  true
                )
              })
            }
          }
          //  清空content 下的options
          this.$changeOptionsEV(
            "",
            "content." + i + ".options.dataId",
            false,
            null,
            {
              container_id: this.ids.container_id,
              rect_id: this.ids.rect_id,
              elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
              path: this.ids.path
            },
            true
          )
          this.$changeOptionsEV(
            "",
            "content." + i + ".options.dataUrl",
            false,
            null,
            {
              container_id: this.ids.container_id,
              rect_id: this.ids.rect_id,
              elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
              path: this.ids.path
            },
            true
          )
        }
      }
    },
    listenStorage(e) {
      if (e.key == "page-v2-data-update") {
        // 后台配置或数据更新
        console.log("后台配置或数据更新 :>>")
        this.startDraw()
      }
    }
  },
  created() {
    this.noCacheComponent && this.getBaseModuleDataLoop()
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.listenStorage)
  }
  // initDataPageIds(newParam) {
  //   const dataPageIds = this.$store.state.states.getDataPageIds
  //   const param = { ...dataPageIds, ...newParam }
  //   if (!!newParam) {
  //     Object.keys(newParam).forEach(key => (param[key] === newParam[key] ? "" : param[key] === newParam[key]))
  //     this.$store.commit("states/updateDataPageIds", param)
  //   }
  //   return param
  // }
}
</script>

<style lang="scss" scoped>
.col_li {
  padding-left: 8px;
}
.col_li:hover {
  background: var(--themeColorSelectBg);
}
.syncCol_flex {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.syncCol_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 80px;
  height: 28px;
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dataSource-item .link {
  color: var(--themeColor);
  cursor: pointer;
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: rgba(0, 0, 0, 0.2);
}

.syncCol_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px 4px;
}

::v-deep .el-button--primary {
  background-color: var(--themeColor);
}
::v-deep .el-radio {
  margin-top: 16px;
}
::v-deep .el-el-radio__label {
  font-size: 14px;
  line-height: 20px;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 8px;
}
::v-deep .mapping_content .el-input .el-input__inner {
  background: var(--leftMenuBgColor);
}
::v-deep .mapping_date_content .el-input .el-input__inner {
  background: var(--inputArrowBgColor);
}
.dataControl {
  margin-top: 24px;
  & .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
  & .subtitle {
    font-size: 16px;
    line-height: 22px;
    display: inline-block;
    margin-top: 4px;
  }
  & .headBox {
    margin-top: 16px;
    margin-bottom: 36px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .preventWorld {
      margin-bottom: 0;
      margin-right: 16px;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
    }
  }
}
.dataPreventControl {
  margin-top: 37px;
  & .headBox {
    display: flex;
    flex-direction: row;
    align-items: center;
    .preventWorld {
      margin-bottom: 0;
      margin-right: 16px;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
    }
  }
  & .radioBox {
    display: flex;
    flex-direction: column;
    //   justify-content: right;
    align-items: flex-start;
  }
}
.mapping_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px;
  color: var(--elCollapseItemContentColor);
}
.mapping_content:not(:last-child) {
  margin-bottom: 8px;
}
.mapping_content:hover {
  background: var(--themeColorSelectBg);
}
.select_content {
  margin-top: 8px;
}
.linkDataBtn {
  width: 100%;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--themeColor);
  padding: 8px 0px;
  cursor: pointer;
}
.DateLabel {
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.4);
}
.verticallyBetweenCenter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.clear-url-btn {
  width: 100%;
  margin-bottom: 16px;
}
.el-button.clear-url-btn:hover,
.el-button.clear-url-btn:focus {
  background-color: transparent;
}
</style>
